const WILL_GET_CUSTOM_DATA = true;

const CATEGORY = {
    FIND_TENANT: 'FindTenant',
    MANAGE_TENANT: 'ManageTenant',
};

const LABEL = {
    CLICK: 'Click',
    TO_FIND_TENANTS: 'ToFindTenants',
    TO_MANAGE_TENANTS: 'ToManageTenants',
};

const ACTION = {
    TOGGLE: 'Toggle',
    EDIT_PROPERTY_ADDRESS: 'EditPropertyAddress',
};

const GA_EVENTS = {
    FIND_TENANTS_TOGGLE: {
        category: CATEGORY.FIND_TENANT,
        label: LABEL.TO_FIND_TENANTS,
        action: ACTION.TOGGLE,
    },
    MANAGE_TENANTS_TOGGLE: {
        category: CATEGORY.MANAGE_TENANT,
        label: LABEL.TO_MANAGE_TENANTS,
        action: ACTION.TOGGLE,
    },
    EDIT_PROPERTY_CLICK: {
        category: WILL_GET_CUSTOM_DATA,
        label: LABEL.CLICK,
        action: ACTION.EDIT_PROPERTY_ADDRESS,
    },
};

export {
    GA_EVENTS,
};
